import { render, staticRenderFns } from "./index.vue?vue&type=template&id=6bb34011&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=6bb34011&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6bb34011",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\zjj\\view-pc\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('6bb34011')) {
      api.createRecord('6bb34011', component.options)
    } else {
      api.reload('6bb34011', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=6bb34011&scoped=true", function () {
      api.rerender('6bb34011', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/customer/setup/customForm/index.vue"
export default component.exports